type OgParams = {
    title: string
    description?: string | null
    imageId?: string | null
    url?: string
    websiteSettings?: {
        ogTitle?: string | null
        ogDescription?: string | null
        ogImageId?: string | null
    } | null
}

/**
 * Facebook treats og:url as the canonical address and drops the whole preview when it is relative,
 * which is what a build without VITE_WEB_URL produces. Leaving the tag out is safe: the crawler then
 * uses the url it scraped.
 */
const isAbsoluteUrl = (url: string): boolean => /^https?:\/\//i.test(url)

export const buildOgMeta = ({ title, description, imageId, url, websiteSettings }: OgParams) => {
    const backendUrl = import.meta.env.VITE_BACKEND_URL || ''

    const ogTitle = title
    const ogDescription = description || websiteSettings?.ogDescription || ''
    const ogImageId = imageId || websiteSettings?.ogImageId
    const imageUrl = ogImageId ? `${backendUrl}/files/${ogImageId}` : ''

    return [
        { title: ogTitle },
        { name: 'description', content: ogDescription },
        { property: 'og:title', content: ogTitle },
        { property: 'og:description', content: ogDescription },
        ...(imageUrl
            ? [
                  { property: 'og:image', content: imageUrl },
                  { name: 'twitter:image', content: imageUrl },
              ]
            : []),
        { property: 'og:type', content: 'website' },
        ...(url && isAbsoluteUrl(url) ? [{ property: 'og:url', content: url }] : []),
        { name: 'twitter:card', content: 'summary_large_image' },
        { name: 'twitter:title', content: ogTitle },
        { name: 'twitter:description', content: ogDescription },
    ]
}
